/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC, useCallback, useRef } from "react";
import { Handle, HandleProps } from "@adapptio/vendor-react-flow-renderer";
import { Icon, ICON_SIZE } from "../Icon";
import { Tooltip } from "../Tooltip";

export type IFlowEditorHandleProps = HandleProps & {
	tooltip?: string;
	icon?: string;
	className?: string;
	style?: React.CSSProperties;
};

export const FlowEditorHandle: FC<IFlowEditorHandleProps> = (props) => {
	const innerElRef = useRef<HTMLDivElement>();

	const handleMouseDown = useCallback(() => {
		innerElRef.current.style.pointerEvents = "none";
	}, []);

	const handleMouseOut = useCallback(() => {
		innerElRef.current.style.pointerEvents = "";
	}, []);

	return (
		<Handle
			type={props.type}
			position={props.position}
			isConnectable={props.isConnectable}
			onConnect={props.onConnect}
			isValidConnection={props.isValidConnection}
			id={props.id}
			className={props.className}
			style={props.style}
		>
			<div
				className="edt-flow-editor__node-handle-inner"
				ref={innerElRef}
				onMouseDown={handleMouseDown}
				onMouseOut={handleMouseOut}
			>
				{props.icon ? <Icon size={ICON_SIZE.CUSTOM} name={props.icon} /> : null}
			</div>
			{props.tooltip ? (
				<Tooltip for={innerElRef} openDelay={1000}>
					{props.tooltip}
				</Tooltip>
			) : null}
		</Handle>
	);
};
